import ApiService from '../services/servicesApi'
// import { GOOGLE_API } from '@/config/app'
// import { ElNotification } from 'element-plus'
import store from '@/store/index'
import { useCookies } from "vue3-cookies"
import { useRouter } from 'vue-router'

import { V1_REDIS_GET_KEY } from '@/api/const/redis'
import { V1_VEW, V1_VEW_POST, V1_VEW_BY_ID, AMIN_V1_VEW_POST, V1_VEW_GET } from '@/api/const/view'
import commons from '@/utils/Common'
import messageShow from '@/utils/MessageShow'

const getError = (error: any) => {

    console.log('error1111', error)
    // const { cookies } = useCookies()
    // const router = useRouter()

    //   const res = error.response

    //             if (!res) return Promise.reject(error)
                

    //             const data = res.data
    //            console.log("data =", data);
    //             console.log("status =", data.status, typeof data.status);
    //             console.log("statusCode =", data.data?.statusCode, typeof data.data?.statusCode);
    //             console.log("status == 400", data.status == 400);
    //             console.log("status === 400", data.status === 400);
                
    //             let statusCode = data?.data.statusCode 
    //             let status = data?.status 
    //             if (status == 400) {
    //                 console.log('vao day statusCode');
    //                 // messageShow.errorList(...);
    //                 console.log('sau errorList');
    //             }
    //             // if(status == 400){
    //             //     console.log('vao day statusCode')
    //             //     messageShow.errorList("msg." + data.messageCode, data.errorsList, 'topRight')
    //             // } else {
    //             //     console.log('vao day status')
    //             //         if (data?.status === 400) {
                        
    //             //         messageShow.error(data.title, data.detail, 'topRight')
    //             //     }
    //             // }

    //             if (res.status === 401 || res.status === 403) {
    //                 // 401 -> refresh token -> lấy access token mới  ->retry request -> thất bại mới logout
    //                 messageShow.error('Error ' + res.status, 'Authoration')
    //                 commons.loginErrorAuth()
    //                 router.push('/login')
    //             }
};
const changeToken = () => {
    ApiService.init()
};

// export const uploadFileAlfresco = async (files: []) => {
//   console.log("files", files)
//   let dataReq = new FormData();
//   files.forEach((file: any) => {
//     dataReq.append("files", file.raw);
//   })
//   dataReq.append("relativePath", '/demo/upload');
//   return await apiPost(API_POST_UPLOAD_MULTI_FILE, dataReq);
// }

// export const getFileAlfresco = async (nodeId, attachment) => {
//   return await apiGetFileNoParam(`${API_GET_DOWNLOAD_FILE}?nodeId=${nodeId}&attachment=${attachment}`)
// }

export const apiPost = async (url: string, data: any) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.post(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            reject(getError(error));
        })
    })
};
export const apiPostV2 = async (url: string, data: any) => {
    try {
        const response = await ApiService.post(url, data);
        return response.data.data;
    } catch (error) {
        const err = getError(error);
        throw err;
    }
};

export const postKey = async (url: string, data: any) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.post(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiPatch = async (url: string, data: any) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.patch(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};
export const apiGet = async (url: string, data: any) => {
    return new Promise((resolve, reject) => {
        ApiService.get(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};
export const apiGetNoParam = async (url: string) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.getNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};
export const apiGetFileNoParam = async (url: string) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.getFileNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};
export const apiPostNoParam = async (url: string) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.postNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiRedis = async (code: string) => {
    changeToken()
    let url = V1_REDIS_GET_KEY + "?key=" + code
    return new Promise((resolve, reject) => {
        ApiService.getNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiGetV2 = async (url: string) => {
    changeToken()
    return new Promise((resolve, reject) => {
        ApiService.getNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiView = async (code: string) => {
    changeToken()
    let url = V1_VEW + code
    return new Promise((resolve, reject) => {
        ApiService.getNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiViewDetail = async (code: string, id: any) => {
    changeToken()
    let url = V1_VEW_BY_ID + id + "/" + code
    return new Promise((resolve, reject) => {
        ApiService.getNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiViewPost= async ( data: any) => {
    changeToken()
    let url = V1_VEW_POST  
    return new Promise((resolve, reject) => {
        ApiService.post(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiViewGet= async ( code: string) => {
    changeToken()
    let url = V1_VEW_GET + code 
    return new Promise((resolve, reject) => {
        ApiService.getNoParam(url).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiAdminViewPost= async ( data: any) => {
    changeToken()
    let url = AMIN_V1_VEW_POST  
    return new Promise((resolve, reject) => {
        ApiService.post(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

// export const apiAddressGoogleMaps = async (lat: number, lng: number) => {
//     store.dispatch("setLoading", true);
//     return new Promise((resolve, reject) => {
//         let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
//         lat +
//         "," +
//         lng +
//         "&key=" + GOOGLE_API
//         ApiService.postNoParam(url).then(response => {
//             store.dispatch("setLoading", false);
//             resolve(response)
//         }).catch(error => {
//             store.dispatch("setLoading", false);
//             throw getError(error);
//         })
//     })
// };

// export const apiLatlngGoogleMaps = async (address: string) => {
//     store.dispatch("setLoading", true);
//     return new Promise((resolve, reject) => {
//         let url = "https://maps.googleapis.com/maps/api/geocode/json?address=" +
//         address +
//         "," + "&key=" + GOOGLE_API
//         ApiService.postNoParam(url).then(response => {
//             store.dispatch("setLoading", false);
//             resolve(response)
//         }).catch(error => {
//             store.dispatch("setLoading", false);
//             throw getError(error);
//         })
//     })
// };

// export const apiDistanceMatrix = async (lat: number, lng: number) => {
//     store.dispatch("setLoading", true);
//     return new Promise((resolve, reject) => {
//         let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
//         lat +
//         "," +
//         lng +
//         "&key=" + GOOGLE_API
//         ApiService.postNoParam(url).then(response => {
//             store.dispatch("setLoading", false);
//             resolve(response)
//         }).catch(error => {
//             store.dispatch("setLoading", false);
//             throw getError(error);
//         })
//     })
// };

export const apiGetIP = async () => {
    store.dispatch("setLoading", true);
    return new Promise((resolve, reject) => {
        let url = "https://ipinfo.io/?token=94ada7ae90eb94"
        ApiService.getNoParam(url).then(response => {
            store.dispatch("setLoading", false);
            resolve(response)
        }).catch(error => {
            store.dispatch("setLoading", false);
            throw getError(error);
        })
    })
};

export const apiGetCaptcha = async (secret: string, token: string) => {
    store.dispatch("setLoading", true);
    return new Promise((resolve, reject) => {
        let url = "https://www.google.com/recaptcha/api/siteverify?secret=" +
            secret +
            "&response=" +
            token
        ApiService.getNoParam(url).then(response => {
            store.dispatch("setLoading", false);
            resolve(response)
        }).catch(error => {
            store.dispatch("setLoading", false);
            throw getError(error);
        })
    })
};

export const apiGetCaptcha2 = async (data: string) => {
    store.dispatch("setLoading", true);
    return new Promise((resolve, reject) => {
        let url = "https://www.google.com/recaptcha/api/siteverify"
        ApiService.postNoParam(url).then(response => {
            store.dispatch("setLoading", false);
            resolve(response)
        }).catch(error => {
            store.dispatch("setLoading", false);
            throw getError(error);
        })
    })
};

export const uploadFileOne = async (data: object) => {
    return new Promise((resolve, reject) => {
        let url = "https://cloud.ha-soft.vn/api/v1/file/upload"
        ApiService.uploadFile(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const uploadFileAvatar = async (data: object) => {
    return new Promise((resolve, reject) => {
        let url = "https://cloud.ha-soft.vn/api/v1/file/avatar"
        ApiService.uploadFile(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const uploadFileMultiple = async (data: object) => {
    return new Promise((resolve, reject) => {
        let url = "https://cloud.ha-soft.vn/api/v1/file/uploads"
        ApiService.uploadFile(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};


export const uploadFile = async (url: string, data: object) => {
    return new Promise((resolve, reject) => {
        ApiService.uploadFile(url, data).then(response => {
            resolve(response)
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const apiDelete = async (url: string) => {
    store.dispatch("setLoading", true);
    return new Promise((resolve, reject) => {
        ApiService.deleteNoParam(url).then(response => {
            let status = response.data.statusCode
            if (status == 200) {
                store.dispatch("setLoading", false);
                resolve(response)
            } else {
                store.dispatch("setLoading", false);
                // ElNotification({
                //     title: url,
                //     message: response.data.errorMessage,
                //     type: 'error',
                // })
            }
        }).catch(error => {
            throw getError(error);
        })
    })
};

export const localhostPost = async (strUrl: any, params: any) => {
    store.dispatch("setLoading", true);
    return new Promise((resolve, reject) => {
        let url = "locahost:8075" + strUrl
        ApiService.post(url, params).then(response => {
            store.dispatch("setLoading", false);
            resolve(response)
        }).catch(error => {
            store.dispatch("setLoading", false);
            throw getError(error);
        })
    })
};

